import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";

export interface FirebaseClientBundle {
  app: FirebaseApp;
  auth: Auth;
  db: Firestore;
}

let bundle: FirebaseClientBundle | null = null;

function readConfig() {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  const appId = import.meta.env.VITE_FIREBASE_APP_ID;
  if (!apiKey || !authDomain || !projectId || !appId) {
    return null;
  }
  return {
    apiKey,
    authDomain,
    projectId,
    appId,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  };
}

/** Returns null when Firebase web config is not present (guest-only mode). */
export function getFirebase(): FirebaseClientBundle | null {
  if (bundle) {
    return bundle;
  }
  const config = readConfig();
  if (!config) {
    return null;
  }
  const app = initializeApp(config);
  bundle = {
    app,
    auth: getAuth(app),
    db: getFirestore(app),
  };
  return bundle;
}

export function isFirebaseConfigured(): boolean {
  return readConfig() !== null;
}
